'use client'
import { FunctionComponent } from 'react'
import { getIsKoreaLocale } from '../../utils/locale.utils'
import { CustomCmsSeller } from '../../../domain/seller'
import { useLoadGoogleMapApi } from '../SellersMap/GoogleMap/helpers'
import { useLoadNaverMapApi } from '../SellersMap/Naver/helpers'
import { useTranslation } from '../../context/ConfigContext'

import StoreInformationPage from './StoreInformationPage'
import useCurrentLocale from '../../../core/hook/useCurrentLocale'

type StoresProps = {
  seller: CustomCmsSeller
}

const Stores: FunctionComponent<StoresProps> = ({ seller }) => {
  const currentLocale = useCurrentLocale()
  const isLoaded = getIsKoreaLocale(currentLocale) ? useLoadNaverMapApi() : useLoadGoogleMapApi()
  const t = useTranslation()

  if (!isLoaded) {
    return <div>{t('Loading...', {}, true)}</div>
  }

  return <StoreInformationPage seller={seller} />
}

export default Stores
